import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { Views } from 'react-big-calendar';

import i18n from 'FRONTEND/utils/i18n';

type CalendarNavigationProps = {
  date: Date;
  localizer: {
    format: (date: Date, format: string) => string;
  };
  onNavigate: (action: string) => void;
  selectedView: string;
  isSmall?: boolean;
}

const CalendarNavigation = (props: CalendarNavigationProps) => {
  const { date, localizer, onNavigate, selectedView } = props;
  const dayName = localizer.format(date, 'dddd');
  const capitalizedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
  const dayNumber = localizer.format(date, 'D');
  const isCurrentDay = localizer.format(date, 'YYYY-MM-DD') === localizer.format(new Date(), 'YYYY-MM-DD');
  const capitalizedMonth = localizer.format(date, 'MMMM').charAt(0).toUpperCase() + localizer.format(date, 'MMMM').slice(1);
  const year = localizer.format(date, 'YYYY');

  const theme = useTheme();
  const arrowButtonStyles = {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    padding: 0,
    height: 40,
    width: 40,
    minHeight: 40,
    minWidth: 40,
    border: `0.5px solid ${theme.palette.grey[700]}`,
  };

  return (
    <>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        pb={1}
        sx={{ position: 'relative' }}
      >
        <Typography variant='h6' fontWeight={600} fontSize={props.isSmall ? 18 : 24} sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
          {capitalizedMonth} {year}
        </Typography>
        <Button
          variant='outlined'
          sx={{
            padding: '0px 20px',
            fontSize: '14px',
            fontWeight: 700,
            backgroundColor: theme => theme.palette.background.paper,
            height: 40,
            minHeight: 40,
          }}
          size='small'
          onClick={() => onNavigate('TODAY')}
        >
          {i18n._('Today')}
        </Button>
        <Stack direction='row'>
          <Button
            onClick={() => onNavigate('PREV')}
            sx={{ ...arrowButtonStyles, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          >
            <ChevronLeftIcon sx={{ fontSize: '25px' }} />
          </Button>
          <Button
            onClick={() => onNavigate('NEXT')}
            sx={{ ...arrowButtonStyles, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          >
            <ChevronRightIcon sx={{ fontSize: '25px' }} />
          </Button>
        </Stack>
      </Stack>
      {/* Optionally render single day header when needed here since we are overriding the default toolbar behavior */}
      {selectedView === Views.DAY && (
        <Stack
          alignItems='center'
          justifyContent='center'
          direction='row'
          bgcolor={theme => theme.palette.background.paper}
          py={1}
        >
          <Typography
            fontWeight={700}
            px={1}
            color={isCurrentDay ? 'primary.main' : 'text.primary'}
            sx={{ textAlign: 'center' }}
          >
            {capitalizedDayName}
          </Typography>
          <Typography
            variant='subtitle2'
            color={isCurrentDay ? 'primary.main' : 'text.secondary'}
            px={1}
          >
            {dayNumber}
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default CalendarNavigation;
